import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const OrderNow = ({
  orderNowList,
  contentfulError,
  viewType,
  installServices,
  setInstallServices,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { orderNow }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching addons data from contentful
        </Notification>
      )}

      {!contentfulError && orderNowList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{orderNow}</Typography></SectionHeading>
            <Table
              viewType={viewType}
              service={installServices}
              setService={setInstallServices}
              list={orderNowList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

OrderNow.propTypes = {
  orderNowList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  viewType: PropTypes.string.isRequired,
  installServices: PropTypes.shape({}).isRequired,
  setInstallServices: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default OrderNow;
